var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1215 -341)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 16,
    transform: "translate(1215 341)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,0,0,2,16V44A14,14,0,0,0,16,58H44A14,14,0,0,0,58,44V16A14,14,0,0,0,44,2H16m0-2H44A16,16,0,0,1,60,16V44A16,16,0,0,1,44,60H16A16,16,0,0,1,0,44V16A16,16,0,0,1,16,0Z",
    transform: "translate(1215 341)",
    fill: "#d9e1e7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1257,379v-2a3,3,0,0,0-2.25-2.9,1,1,0,0,1,.5-1.937A5,5,0,0,1,1259,377v2a1,1,0,0,1-2,0Zm-6,0v-2a3,3,0,0,0-3-3h-8a3,3,0,0,0-3,3v2a1,1,0,1,1-2,0v-2a5,5,0,0,1,5-5h8a5,5,0,0,1,5,5v2a1,1,0,0,1-2,0Zm-12-14a5,5,0,1,1,5,5A5,5,0,0,1,1239,365Zm2,0a3,3,0,1,0,3-3A3,3,0,0,0,1241,365Zm9.031,4.128a1,1,0,0,1,.72-1.217,3,3,0,0,0,0-5.812,1,1,0,0,1,.5-1.938,5,5,0,0,1,0,9.688,1,1,0,0,1-1.216-.721Z",
    fill: "#809fb8"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.09271393285a951ae555079829913da4.svg";
export { ForwardRef as ReactComponent };